import { z } from 'zod';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { uuid } from '../../utils';

export const publicProgram = extendApi(
  z.object({
    id: uuid,
    name: extendApi(z.string(), {
      description: 'Name displayed in the Manager',
      example: 'My brand loyalty program',
    }),
  }),
  {
    description: 'Program that the event is related to',
    tags: ['program-model', 'program', 'model'],
  } as RedocSchemaObject,
);

export const publicProgramRef = extendApi(publicProgram, {
  $ref: '#/components/schemas/Program',
} as RedocSchemaObject);

export type PublicProgram = z.infer<typeof publicProgram>;
